import {
  ActionIcon,
  Button,
  Pagination,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import TablePagination from "../componenets/Common/TablePagination";
import UniversalTable from "../componenets/Common/UniversalTable";
import React, { useEffect, useState } from "react";
import {
  acceptObligation,
  fetchDraftObligations,
  getTitlesApi,
} from "../apis/obligationApi";
import { DatePicker } from "@mantine/dates";
import {
  converDateToISO,
  convertToISO8601,
  departmentData,
  formatDatetoISO,
  formatDatetoIST,
  getActFrequencyText,
  getDepartmentText,
  getRecFrequencyText,
} from "./utilities";
import {
  fetchBuOptions,
  getDeptUsers,
  getNamesofAgreement,
} from "../apis/userApis";

function DraftObligations() {
  const [obligations, setObligations] = useState([]);
  const [configs, setConfigs] = useState({
    loading: true,
    count: true,
    refresh: true,
  });
  const [uiConfigs, setUiConfigs] = useState({
    page: 1,
    pageSize: 10,
  });
  const [buData, setBuData] = useState([]);
  const [filters, setFilters] = useState({});
  const [titleOptions, setTitleOptions] = useState([]);
  const [applyfilters, setApplyFilters] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [assignToData, setAssignToData] = useState([]);
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      setBuData(response.buData);
    };
    getBuData();
    const getTitles = async () => {
      const response = await getTitlesApi();
      if (response.success) {
        setTitleOptions(response.titles);
      }
    };
    getTitles();
  }, []);
  useEffect(() => {
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getNames();
    const getassignToUsers = async () => {
      const response = await getDeptUsers();
      setAssignToData(response.userData);
    };
    getassignToUsers();
  }, []);
  useEffect(() => {
    const getDraftObligation = async () => {
      const response = await fetchDraftObligations({ ...uiConfigs, filters });
      if (response.success) {
        setObligations(response.obligations);
        setConfigs({ ...configs, loading: false, count: response.count });
      }
    };
    getDraftObligation();
  }, [uiConfigs.page, uiConfigs.pageSize, configs.refresh, applyfilters]);
  return (
    <div>
      <Text className="flex justify-center font-bold text-xl my-4">
        draft obligations
      </Text>

      <div className="grid grid-cols-6 gap-4 m-4">
        <Select
          searchable
          label="department"
          placeholder="select department"
          data={departmentData}
          onChange={(val) => setFilters({ ...filters, department: val })}
          value={filters?.department}
        />
        <Select
          searchable
          label="title"
          placeholder="select title"
          data={titleOptions}
          onChange={(val) => setFilters({ ...filters, title: val })}
          value={filters?.title}
        />
        <Select
          searchable
          label="business unit"
          placeholder="select business unit"
          value={filters?.businessUnit}
          data={buData}
          onChange={(val) => setFilters({ ...filters, businessUnit: val })}
        />
        <Select
          searchable
          label="Contract Category"
          placeholder="Contract Category"
          value={filters?.extraCol1}
          data={categoryOptions}
          onChange={(val) => setFilters({ ...filters, extraCol1: val })}
        />
        <TextInput
          label="second party name"
          placeholder="type party name"
          // value={filters["OR"]}
          onChange={(e) =>
            setFilters({
              ...filters,
              OR: [
                { brandName: { contains: e.target.value } },
                { connectedParty: { contains: e.target.value } },
              ],
            })
          }
        />
        <TextInput
          label="job order"
          placeholder="job order"
          value={filters.joOrder}
          onChange={(e) =>
            setFilters({
              ...filters,
              joOrder: e.target.value,
            })
          }
        />
      </div>
      <div className="m-4">
        <Button
          onClick={() => setApplyFilters(!applyfilters)}
          className="mr-4"
          variant="outline"
        >
          Search
        </Button>
        <Button
          onClick={() => {
            window.location.reload();
            // setFilters(filterForUser);
            // setPartyName("");
            // setStatus(null);
            // setApplyFilters(!applyfilters);
          }}
          color="#1b6f8d"
        >
          Clear
        </Button>
      </div>

      <UniversalTable
            headers={[
              {
                label: "obligation id",
                align: "center",
                render: (row) => <Text size="sm">{row.id}</Text>,
              },
              {
                label: "obligation title",
                align: "center",
                render: (row) => <Text size="sm" weight={600}>{row.title}</Text>,
              },
              {
                label: "description",
                align: "center",
                render: (row) => <Text size="sm">{row.desc}</Text>,
              },
              {
                label: "job order",
                align: "center",
                render: (row) => <Text size="sm">{row.joOrder || "--"}</Text>,
              },
              {
                label: "second party",
                align: "center",
                render: (row) => (
                  <div>
                    <Text size="sm" weight={600}>{row.brandName}</Text>
                    <Text size="xs" c="dimmed">{"("} {row.connectedParty} {")"}</Text>
                  </div>
                ),
              },
              {
                label: "department",
                align: "center",
                render: (row) => <Text size="sm">{getDepartmentText(row.department)}</Text>,
              },
              {
                label: "assign to",
                align: "center",
                render: (row) => (
                  <Select
                    data={assignToData}
                    value={row.assignToId}
                    onChange={(val) => {
                      setObligations((prevData) =>
                        prevData.map((obligation) =>
                          obligation.id === row.id
                            ? { ...row, assignToId: val }
                            : obligation
                        )
                      );
                    }}
                    size="xs"
                  />
                ),
              },
              {
                label: "start date",
                align: "center",
                render: (row) => (
                  <DatePicker
                    className="max-w-lg"
                    value={row.startDate}
                    onChange={(val) => {
                      setObligations((prevData) =>
                        prevData.map((obligation) =>
                          obligation.id === row.id
                            ? {
                                ...row,
                                startDate: convertToISO8601(converDateToISO(val)),
                              }
                            : obligation
                        )
                      );
                    }}
                    size="xs"
                  />
                ),
              },
              {
                label: "end date",
                align: "center",
                render: (row) => (
                  row.actFrequency === 1 ? (
                    <DatePicker
                      value={row.endDate}
                      onChange={(val) => {
                        setObligations((prevData) =>
                          prevData.map((obligation) =>
                            obligation.id === row.id
                              ? {
                                  ...row,
                                  endDate: convertToISO8601(converDateToISO(val)),
                                }
                              : obligation
                          )
                        );
                      }}
                      size="xs"
                    />
                  ) : (
                    <Text size="sm">{formatDatetoISO(row.endDate)}</Text>
                  )
                ),
              },
              {
                label: "act. frequency",
                align: "center",
                render: (row) => <Text size="sm">{getActFrequencyText(row.actFrequency)}</Text>,
              },
              {
                label: "rec. frequency",
                align: "center",
                render: (row) => <Text size="sm">{getRecFrequencyText(row.recFrequency)}</Text>,
              },
              {
                label: "reminder time",
                align: "center",
                render: (row) => (
                  <Select
                    data={[
                      { label: "1-day", value: 1 },
                      { label: "2-days", value: 2 },
                      { label: "3-days", value: 3 },
                      { label: "4-days", value: 4 },
                      { label: "5-days", value: 5 },
                      { label: "6-days", value: 6 },
                      { label: "7-days", value: 7 },
                      { label: "10-days", value: 10 },
                      { label: "15-days", value: 15 },
                      { label: "30-days", value: 30 },
                      { label: "45-days", value: 45 },
                      { label: "60-days", value: 60 },
                      { label: "90-days", value: 90 },
                    ]}
                    value={row.reminderTime}
                    onChange={(val) => {
                      setObligations((prevData) =>
                        prevData.map((obligation) =>
                          obligation.id === row.id
                            ? { ...row, reminderTime: val }
                            : obligation
                        )
                      );
                    }}
                    size="xs"
                  />
                ),
              },
              {
                label: "actions",
                align: "center",
                render: (row) => (
                  <Button
                    variant="outline"
                    size="xs"
                    onClick={async () => {
                      const response = await acceptObligation({
                        id: row.id,
                        startDate: row.startDate,
                      });
                      if (response.success) {
                        setConfigs({
                          ...configs,
                          refresh: !configs.refresh,
                        });
                        window.location.reload();
                      }
                    }}
                  >
                    Save
                  </Button>
                ),
              },
            ]}
            data={obligations}
            loading={configs.loading}
          />
          <TablePagination
            totalCount={configs.count}
            page={uiConfigs.page}
            pageSize={uiConfigs.pageSize}
            dataLength={obligations?.length || 0}
            onPageChange={(page) => setUiConfigs({ ...uiConfigs, page })}
            onPageSizeChange={(val) => setUiConfigs({ ...uiConfigs, pageSize: val, page: 1 })}
          />
      {obligations?.length > 0 && (
        <div className="flex flex-row justify-center my-4 gap-4">
          <Pagination
            color="#1b6f8d"
            page={uiConfigs.page}
            onChange={(page) => {
              setUiConfigs({ ...uiConfigs, page });
            }}
            total={Math.ceil(configs.count / uiConfigs.pageSize)}
          />

          <Select
            style={{ width: "70px" }}
            value={uiConfigs.pageSize + ""}
            data={["10", "20", "50"]}
            onChange={(val) =>
              setUiConfigs({ ...uiConfigs, pageSize: parseInt(val) })
            }
          />
        </div>
      )}
    </div>
  );
}

export default DraftObligations;
